export const AIRPORT_TYPES = ['SMALL_AIRPORT', 'MEDIUM_AIRPORT', 'LARGE_AIRPORT'];
export const NAVAID_TYPES = ['VOR', 'DME', 'VORDME', 'NDB', 'WAYPOINT'];
export const AIRPORTS_MIN_ZOOM_LEVEL = 5.7;
export const NAVAIDS_MIN_ZOOM_LEVEL = 7.3;